import { RequestHandler } from "../Utils/request_handler"

interface condition {
  id: number
  name: string
  path?: string
}

export class PlaceSearcher {
  path: string
  query: string
  onLoad: Function

  constructor(
    path: string,
    options: {
      category: condition
      city: condition
      prefecture: condition
      onLoad: Function
      page?: number
      from?: string
    }
  ) {
    this.path = path
    const conditions = {
      category_id: null,
      city_id: null,
      prefecture_id: null,
      page: 1,
      from: "",
    }
    if (options.category) {
      conditions.category_id = options.category.id
    }
    if (options.city) {
      conditions.city_id = options.city.id
    }
    if (options.prefecture) {
      conditions.prefecture_id = options.prefecture.id
    }
    if (options.page) {
      conditions.page = options.page
    }
    if (options.from) {
      conditions.from = options.from
    }
    this.onLoad = options.onLoad
    this.query = Object.keys(conditions)
      .map((c) => `${c}=${conditions[c]}`)
      .join("&")
  }

  async search() {
    const handler = new RequestHandler(`${this.path}?${this.query}`, "GET")
    const res = await handler.requestWithBody()
    this.onLoad(res.body, res.status)
  }
}
